import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import {
    ID2CResponse,
    IStageApiResponse,
    IRequestRegistrationData,
    ICibilDataWrapper,
    AlternateMobileNumber,
} from "../d2c.interface";

@Injectable({ providedIn: "root" })
export class D2cApiService {
    private readonly baseUrl = environment.baseUrl;

    constructor(private readonly http: HttpClient) {}

    /** 🔹 GET: current DTC stage */
    getStage(): Observable<IStageApiResponse> {
        return this.handleGet<IStageApiResponse>(`${this.baseUrl}/dtc/stage`);
    }

    /** 🔹 POST: submit new DTC registration request */
    submitRequest(payload: { fullName: string }): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/dtc/submit/request`, payload);
    }

    /** 🔹 POST: submit alternate number */
    submitAltNumber(payload: AlternateMobileNumber): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/dtc/submit/alt_number`, payload);
    }

    /** 🔹 POST: submit OTP (mobile/email) */
    submitOtp(payload: Record<string, any>): Observable<IStageApiResponse> {
        return this.http.post<any>(`${this.baseUrl}/dtc/submit/otp`, payload);
    }

    /** 🔹 GET: fetch new CIBIL data */
    getNewCibil(): Observable<ID2CResponse<ICibilDataWrapper>> {
        return this.handleGet<ICibilDataWrapper>(`${this.baseUrl}/dtc/get/new/cibil`);
    }
    /** 🔹 GET: fetch CIBIL web report */
    getWebReport(): Observable<Record<string, any>> {
        return this.handleGet<Record<string, any>>(`${this.baseUrl}/dtc/webtoken`);
    }

    // ------------------------------------------------------------------
    // ✅ Reusable private handlers
    // ------------------------------------------------------------------

    private handleGet<T>(url: string): Observable<ID2CResponse<T>> {
        return this.http.get<ID2CResponse<T>>(url).pipe(catchError((err) => of(err as ID2CResponse<T>)));
    }

    private handlePost<T>(url: string, payload: unknown = {}): Observable<ID2CResponse<T>> {
        return this.http.post<ID2CResponse<T>>(url, payload).pipe(catchError((err) => of(err as ID2CResponse<T>)));
    }
}
